// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import ArkturDMClogoICO from '../../../Library/Images/ArkturDMClogoICO.ico';

// ##### Komarov 2025-07-14
const FORGROUPS = () => {
  // ##### Komarov 2025-07-12
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-component="FORGROUPS">
      <Helmet>
        <title>Arktur Groups</title>
        <link rel="shortcut icon" href={ArkturDMClogoICO} />
      </Helmet>
      <h2>For Groups</h2>
    </div>
  );
};

export default FORGROUPS;
